import React, { useState, useEffect } from 'react';
import PageTitle from '../components/pagetitle';
import { Link } from 'react-router-dom';
import data from '../assets/fake-data/data-blog';

function Blog(props) {
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 9;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [currentPage]);

    const handleClick = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

    const renderPageNumbers = () => {
        const pageNumbers = [];
        for (let i = 1; i <= Math.ceil(data.length / itemsPerPage); i++) {
            pageNumbers.push(
                <li key={i}>
                    <Link to="#" className={currentPage === i ? 'active' : ''} onClick={() => handleClick(i)}>
                        {i}
                    </Link>
                </li>
            );
        }
        return pageNumbers;
    };

    return (
        <div className='inner-page'>
            {<PageTitle title='Blog Grid' />}

            <section className="tf-section tf-blog pt60">
                <div className="overlay" style={{ background: 'rgb(14 3 39 / 50%)' }} />

                <div className="container">
                    <div className="row">
                        {currentItems.map(item => (
                            <div key={item.id} className="col-lg-4 col-md-12">
                                <div className="grid-box">
                                    <div className="image">
                                        <img src={item.img} alt="" />
                                    </div>
                                    <div className="content">
                                        <Link to={`/blog_details/${item.id}`} className="tag">{item.cate}</Link>
                                        <h5 className="title"><Link to={`/blog_details/${item.id}`}>{item.heading}</Link></h5>
                                        <p>{item.text}</p>
                                    </div>
                                    <Link to={`/blog_details/${item.id}`} className="tf-button style1">
                                        Read more
                                    </Link>
                                </div>
                            </div>
                        ))}
                        <div className="col-md-12">
                            <ul className="panigation" >
                                <li>
                                    <Link to="#" onClick={() => handleClick(currentPage - 1)} className={currentPage === 1 ? 'disabled' : ''}>
                                        <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M6.5 1L1.5 6L6.5 11" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </Link>
                                </li>
                                {renderPageNumbers()}
                                <li>
                                    <Link to="#" onClick={() => handleClick(currentPage + 1)} className={currentPage === Math.ceil(data.length / itemsPerPage) ? 'disabled' : ''}>
                                        <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M1.5 1L6.5 6L1.5 11" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Blog;